<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img style="width: 300px" src="@/assets/images/pages/transport.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <vs-input
                        type="number"
                        icon-no-border
                        icon="icon icon-truck"
                        icon-pack="feather"
                        :label-placeholder="$t('EndKilometers')"
                        v-model="endKilometers"
                        class="w-full mt-6" />

                <div style="padding: 30px 30px 30px 0">
                  <vs-button @click="finishTransport" >{{$t("FinishTransport")}}</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      endKilometers: ''
    }
  },
  methods: {
    finishTransport() {
      this.$vs.loading();
      const thisIns = this;
      this.$http.post('/api/v1/transport/stop' , {
        kilometers: Number(this.endKilometers)
      }).then(function (response) {
        thisIns.$store.dispatch('updateTransportStarted', false);
        thisIns.$vs.loading.close();
        if(Number(response.data) !== 0){
          if(response.data.length > 64) {
            window.location.href = "/pdf/travel_order/" + response.data;
          }else{
            thisIns.$router.push({ name: 'task', params: { id: response.data } })
          }

        }else{
          thisIns.$router.push({ name: 'ownTasks' })
        }

      }).catch(function () {
        thisIns.$vs.loading.close();
        thisIns.$vs.notify({
          title:'Error',
          text: "Failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });
    }
  }
}
</script>

<style lang="scss">
</style>
